import type { CancelReplanCancelResponse } from "../../../../../../../../../../../../api/kehrblatt/schedule-events"
import type {
  CancelEventsStepOutput,
  CancelReplanRow,
} from "../../../../../../../_logic/cancel-replan-contract"
import { markRowsWithoutCanceledEventRemoved } from "../../../../../../../_logic/rows"

export const projectCancelAppointmentsOutcome = ({
  rows,
  response,
}: {
  rows: CancelReplanRow[]
  response: CancelReplanCancelResponse
}): CancelEventsStepOutput => {
  const canceledEventById = new Map<string, ScheduleEvent>(
    response.items
      .filter((item) => item.status === "canceled" && item.event?.id)
      .map((item) => [item.event_id, item.event as ScheduleEvent]),
  )
  const canceledIds = new Set(
    response.items.filter((item) => item.status === "canceled").map((item) => item.event_id),
  )

  return {
    rows: markRowsWithoutCanceledEventRemoved(rows, canceledIds).map((row) => {
      const eventId = row.event?.id

      if (!eventId || !canceledIds.has(eventId)) return row

      const event =
        canceledEventById.get(eventId) ??
        (row.event ? ({ ...row.event, status: "CANCELED" } as ScheduleEvent) : null)

      return event ? { ...row, event } : row
    }),
  }
}
